import React from "react";
import { Route, Routes } from "react-router-dom";
import {Main, Pwa, Support, Tools, AboutUs, AffiliateProgram, Faq, Pwa_macOS, Privacy_Policy,Terms_Conditions,Cookie_Policy,Risk_Disclosure,Unsubscribe } from "@components/pages";
import ScrollToTop from "@components/common/ScrollToTop";
import NotFound from "../pages/NotFound/NotFound"
import {
  PWA_PAGE,
  FAQ_PAGE,
  AFFILIATE_PROGRAM_PAGE,
  SUPPORT_PAGE,
  ABOUT_US_PAGE,
  PWA_MACOSPAGE,
  TOOLS_PAGE,
  PRIVACY_POLICY,
  TERMS_CONDITIONS,
  COOKIE_POLICY,
  RISK_DISCLOSURE,
  UNSUBSCRIBE
} from "@constants";

export const AuthWrapper = () => {
  return (
    <>
      <ScrollToTop />

      <Routes>
          <Route index element={<Main />} />
          <Route path={PWA_PAGE} element={<Pwa />} />
          <Route path={FAQ_PAGE} element={<Faq />} />
          <Route path={AFFILIATE_PROGRAM_PAGE} element={<AffiliateProgram />} />
          <Route path={SUPPORT_PAGE} element={<Support />} />
          <Route path={TOOLS_PAGE} element={<Tools />} />
          <Route path={ABOUT_US_PAGE} element={<AboutUs />} />
          <Route path={PWA_MACOSPAGE} element={<Pwa_macOS />} />
          <Route path={PRIVACY_POLICY} element={<Privacy_Policy />} />
          <Route path={TERMS_CONDITIONS} element={<Terms_Conditions />} />
          <Route path={COOKIE_POLICY} element={<Cookie_Policy />} />
          <Route path={RISK_DISCLOSURE} element={<Risk_Disclosure />} />
          <Route path={UNSUBSCRIBE} element={<Unsubscribe />} />

          <Route path="*" element={<NotFound />} />

      </Routes>
    </>
  );
};
